import Api from "../Utilities/Api/ApiMethods";

const authenticateRequest = async params => {
  try {
    const response = await Api.post( "login/authenticate", params );
    return { response: { ...response.data } };
  } catch ( error ) {
    return {
      error: {
        ...error
      }
    };
  }
};

const loginRequest = async params => {
  try {
    const response = await Api.post( "login", params );
    return { response: { ...response.data } };
  } catch ( error ) {
    return {
      error: {
        ...error
      }
    };
  }
};

export default {
  loginRequest, authenticateRequest
};